export const PAGE_HEADER_MIN_HEIGHT = {
    desktop: 84,
    mobile: 58,
};
/** Stacking order of the sticky header; anything meant to float above it has to beat this. */
export const PAGE_HEADER_Z_INDEX = 9;
